export const enum DocType {
  LICENSE_FRONT= "LICENSE_FRONT",
  LICENSE_BACK= "LICENSE_BACK",
  LICENSE_FRONT_AND_BACK= "LICENSE_FRONT_AND_BACK",
  STATE_ID_FRONT= "STATE_ID_FRONT",
  STATE_ID_BACK= "STATE_ID_BACK",
  PASSPORT= "PASSPORT",
  OTHER= "OTHER",
  GREEN_CARD_FRONT = "GREEN_CARD_FRONT",
  GREEN_CARD_BACK = "GREEN_CARD_BACK",
}

export const getFirstDoc = (documents: DocType[]): DocType => {
  // combine dl front and back to signal special wording
  const frontIndex = documents.indexOf(DocType.LICENSE_FRONT);
  const backIndex = documents.indexOf(DocType.LICENSE_BACK);
  if ((frontIndex === 0 || backIndex === 0) && frontIndex >= 0 && backIndex >= 0) {
    return DocType.LICENSE_FRONT_AND_BACK;
  }
  return documents[0];
};

export const orderDocs = (documents: DocType[]): DocType[] => {
  return documents.sort( (a, b) => {
    const aVal = getDocOrder(a);
    const bVal = getDocOrder(b);
    return aVal - bVal;
  });
};

export const getDocOrder = (docType: DocType): number => {
  switch (docType) {
    case DocType.LICENSE_BACK:
    case DocType.GREEN_CARD_BACK:
    case DocType.STATE_ID_BACK: return 1;
    case DocType.LICENSE_FRONT:
    case DocType.GREEN_CARD_FRONT:
    case DocType.STATE_ID_FRONT: return 2;
    default: return 9001;
  }
};



// WEBPACK FOOTER //
// ./src/constants/DocType.ts